import '@ui5/webcomponents/dist/StandardListItem.js';
import { ListItemType, ValueState } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `StandardListItem` represents the simplest type of item for a `StandardListItemst`. This is a list item, providing the most common use cases such as `text`, `image` and `icon`.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/StandardListItem" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const StandardListItem = withWebComponent('ui5-li', ['accessibleName', 'additionalText', 'additionalTextState', 'description', 'icon', 'image', 'type'], ['iconEnd', 'selected'], [], ['detail-click']);
StandardListItem.displayName = 'StandardListItem';
StandardListItem.defaultProps = {
    additionalTextState: ValueState.None,
    type: ListItemType.Active
};
export { StandardListItem };
